// Tender shortcuts on the Express total (UPI / Card / Cash): each one opens the
// pay screen with that payment method picked, through the same pick the pay
// screen already makes for Cash. Names differ by tenant ("GPay", "Credit Card",
// "EDC"), so each shortcut takes the till's first method that reads as it.

const LOOKS_LIKE = {
  upi: /\bupi\b|g ?pay|google ?pay|phone ?pe|paytm|bhim/i,
  card: /card|\bdebit\b|\bvisa\b|master|\bswipe\b|\bedc\b/i,
  cash: /^cash$/i,
};
// Methods that need more than a tap: gift cards, loyalty, wallet, credit sale, credit notes.
const NOT_A_TENDER = /gift|loyal|wallet|voucher|coupon|note/i;

export const TENDER_SHORTCUTS = Object.freeze([
  { key: "upi", label: "UPI" },
  { key: "card", label: "Card" },
  { key: "cash", label: "Cash" },
]);

const usable = (pm) => pm?.name && !pm.isloyalty && pm.isWallet !== "Y" && !pm.iscredit && pm.name !== "Credit" && !NOT_A_TENDER.test(pm.name);

// [{ key, label, name }] for the shortcuts this till can take, in UPI, Card, Cash order.
export function tenderShortcuts(methods) {
  const list = (Array.isArray(methods) ? methods : []).filter(usable);
  const taken = new Set();
  const out = [];
  for (const t of TENDER_SHORTCUTS) {
    const pm = list.find((m) => !taken.has(m.name) && LOOKS_LIKE[t.key].test(m.name));
    if (!pm) continue;
    taken.add(pm.name);
    out.push({ ...t, name: pm.name });
  }
  return out;
}
